import { schema } from 'normalizr';
import elementTypeSchema from './elementType';
import relationshipSchema from './relationship';

const providesTo = new schema.Entity('providesTo');
const consumesFrom = new schema.Entity('consumesFrom');
const tags = new schema.Entity('tags');
const elementSchema = new schema.Entity('elements');


elementSchema.define({
  type: elementTypeSchema,
  children: [elementSchema],
  consumers: [elementSchema],
  producers: [elementSchema],
  parent: elementSchema,
  consumesFrom: [consumesFrom],
  providesTo: [providesTo],
  tags: [tags],
  relationships: [relationshipSchema],
});

export default elementSchema;



// WEBPACK FOOTER //
// ./src/schemas/element.js